export const TILE_EXPORT_FORMATS = ['PNG', 'PDF', 'CSV', 'XLSX'] as const;
export type TileExportFormat = (typeof TILE_EXPORT_FORMATS)[number];

export interface TileExportRequest {
  tileId: string;
  title: string;
  element: HTMLElement;
}

export abstract class TileExportHandler {
  abstract exportTileAs(request: TileExportRequest, format: TileExportFormat): Promise<void>;
}
